import styles from '../less/module.module.less';
import React from 'react';

const ModuleDom = ({ description, moduleOption, tag, ...others }) => {
  // if (+moduleOption === 2) {
  //   return null;
  // }
  return React.createElement(tag, {
    className: styles.moduleLine,
    dangerouslySetInnerHTML: { __html: description },
    ...others
  });
};
ModuleDom.defaultProps = {
  tag: 'li'
};
export default ModuleDom;
